export default __webpack_public_path__ + "static/email-templates-paste-signature-d0a1ef3c61c3e075aae7abaaafdba0ae.mp4";